import { Component, OnInit } from '@angular/core';
import {AuthService, UserData} from '../../auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertService} from '../../alert.service';
import Swiper from '../../../assets/libs/swiper-4.5.0/swiper-4.5.0/dist/js/swiper.min';

@Component({
  selector: 'app-club-member',
  templateUrl: './club-member.component.html',
  styleUrls: ['./club-member.component.sass']
})
export class ClubMemberComponent implements OnInit {

  today: Date = new Date()
  user: firebase.User;
  message: string;
  users: UserData[];
  swiper: Swiper;

  constructor(
    private auth: AuthService,
    private route: ActivatedRoute,
    public alert: AlertService,
    private router: Router) {
  }

  ngOnInit() {
    this.auth.getUserState()
      .subscribe(user => {
        this.user = user;
        if (!this.user) {
          this.router.navigate(['/login'], {
            queryParams: {
              loginAgain: true
            }
          });
        }
      });
    this.swiper = new Swiper('.main_slider', {
      slidesPerView: 1,
      spaceBetween: 0,
      freeMode: false,
      loop: false,
      pagination: {
        el: '.main_slider .swiper-pagination',
        clickable: true
      }
    });
  }

}
